'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable no-undefined */

var helpBotProductKey = 'help-bot-product';
var helpBotProductContextKey = 'help-bot-product-ctx';
var helpBotProductPreviousKey = 'help-bot-product-prev';

/**
 * Gets the product context from session storage.
 *
 * @returns {string}     the product context
 */
function getProductContextFromStorage() {
  if (window.sessionStorage) {
    return window.sessionStorage.getItem(helpBotProductContextKey);
  }
  return '';
}

/**
 * Sets the product context product id in session storage.
 *
 * @param  {string} productId  the current product context product id
 */
function setProductContext(productId) {
  if (window.sessionStorage) {
    if (!productId) {
      window.sessionStorage.setItem(helpBotProductPreviousKey, getProductContextFromStorage());
    }
    window.sessionStorage.setItem(helpBotProductContextKey, productId);
  }
}

/**
 * Returns product id (slug) for current context.  for new conversation this is the
 * product id from url or storage.  for existing conversation it is the last
 * product open since a close of the container (if any) for a given session.
 *
 * @param  {array} conversation       the conversation array
 * @param  {string} urlProductId      the current url product id
 * @returns {string}                  the product context product id
 */
function getProductContext(conversation, urlProductId) {
  if (!conversation) {
    return '';
  }

  var helpIconProductId = window.sessionStorage ? window.sessionStorage.getItem(helpBotProductKey) : '';
  var currentProductId = urlProductId || helpIconProductId;

  // new conversation - first time or previous conversations timed out
  if (!conversation.length) {
    setProductContext(currentProductId);
    return currentProductId;
  }

  // existing conversation - within session timeout and haven't closed container
  var productContext = getProductContextFromStorage();
  if (productContext) {
    return productContext;
  }

  // existing conversation closed - within session timeout and closed container
  setProductContext(currentProductId);
  return currentProductId;
}

/**
 * Gets the previous product context from session storage.
 *
 * @returns {string}     the previous product id
 */
function getPreviousProductId() {
  if (window.sessionStorage) {
    return window.sessionStorage.getItem(helpBotProductPreviousKey);
  }
  return '';
}

/**
 * Sets the previous product context in session storage to empty.
 *
 */
function clearPreviousProduct() {
  if (window.sessionStorage) {
    window.sessionStorage.setItem(helpBotProductPreviousKey, '');
  }
}

exports.default = {
  getProductContext: getProductContext,
  setProductContext: setProductContext,
  getProductContextFromStorage: getProductContextFromStorage,
  getPreviousProductId: getPreviousProductId,
  clearPreviousProduct: clearPreviousProduct
};